<script setup>
defineProps(['active'])
</script>

<template>
  <svg
    :class="{
      'stroke-black dark:stroke-white': !active,
      'stroke-lush-green': active,
      'duration-300': true
    }"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="23" cy="9" r="4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <circle cx="9" cy="23" r="4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M19 19H27V26C27 26.5523 26.5523 27 26 27H20C19.4477 27 19 26.5523 19 26V19Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 5H13V12C13 12.5523 12.5523 13 12 13H6C5.44772 13 5 12.5523 5 12V5Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
